import { useEffect, useState } from "react";
import { analytics } from "../../analytics";
import { useLocationWrapper } from "../../hooks/useLocationWrapper";

import Button from "../ButtonComponent";
import { useParams } from "react-router";
import { Manufacturer } from "../../interfaces";
import TextInput from "../TextInput";
import { useGetNextState } from "../../hooks/useGetNextState";
import { sessionStorageService, SESSION_STORAGE_KEYS } from "../../services/sessionStorage";

// we are missing the device name, display_name prop or something here to be used in the title
interface IState extends Manufacturer {
  redirectUrl: string;
}

const getSerialNumberLabel = (slug: string, displayName: string) => {
  switch (slug) {
    case "franklinwh":
      return `${displayName} aGate serial number`;
    case "solaredge-grid-services":
      return `${displayName} site identifier`;
    case "eg4-electronics":
      return `${displayName} device serial number`;
    default:
      return `${displayName} serial number`;
  }
};

const getSerialNumberContent = (slug: string, displayName: string) => {
  switch (slug) {
    case "franklinwh": {
      return (
        <div>
          <div className="text-texturePennBlue text-center mb-5">
            To find your aGate serial number please open the {displayName} app or locate the number directly on your
            device.
          </div>
        </div>
      );
    }
    case "solaredge-grid-services": {
      return (
        <div>
          <div className="text-texturePennBlue text-center mb-5">
            To find your Site ID locate the number found in your sign up email or in your MySolarEdge app under site
            info.
          </div>
        </div>
      );
    }
    case "eg4-electronics": {
      return (
        <div>
          <div className="text-texturePennBlue text-center mb-5">
            To find your serial number please open the {displayName} app or locate the number directly on your device.
          </div>
        </div>
      );
    }
    default:
      return (
        <div>
          <div className="text-texturePennBlue text-center mb-5">
            To find your serial number please open the {displayName} app or locate the number directly on your device.
          </div>
          <div className="text-texturePennBlue text-center mb-5">
            If you have any questions, please{" "}
            <a className="text-textureIris cursor-pointer" target="_blank" href="https://www.texturehq.com/contact-us">
              reach out to us
            </a>
            .
          </div>
        </div>
      );
  }
};

const getTextInputLabel = (slug: string) => {
  switch (slug) {
    case "solaredge-grid-services":
      return "ID:";
    default:
      return "SN:";
  }
};

export function ConnectManufacturerSerialNumberCapture() {
  const { linkToken = "" } = useParams();
  const { state } = useLocationWrapper<IState>();
  const { getNextState, loading } = useGetNextState(linkToken);
  const systemIdentifier = sessionStorageService.get(SESSION_STORAGE_KEYS.systemIdentifier) || "";
  const [serialNumber, setSerialNumber] = useState<string>(systemIdentifier);

  useEffect(() => {
    if (analytics && analytics.page) {
      analytics.page("connect serial number capture");
    }
  }, []);

  const submitSerialNumber = () => {
    getNextState("manufacturers/system_connection", {
      type: "continue",
      data: {
        manufacturer: state.slug,
        serialNumber: serialNumber,
      },
    });
  };

  return (
    <>
      <div className="hidden tp:block d:block"></div>
      <div className="flex flex-col items-center justify-between gap-8 tp:gap-4 max-w-[40rem]">
        <img src={state.logoUrl} className="mx-auto w-24 h-24" alt="success-logo" />
        <div className="text-texturePennBlue font-bold text-xl d:text-4xl tp:text-2xl text-center">
          {getSerialNumberLabel(state.slug, state.displayName)}
        </div>
        <div className="w-full sm:w-[30rem]">
          <TextInput
            label={getTextInputLabel(state.slug)}
            inputMode="text"
            value={serialNumber}
            autoFocus={!serialNumber}
            onChange={(serial) => setSerialNumber(serial)}
          />
        </div>
        {getSerialNumberContent(state.slug, state.displayName)}
      </div>
      <div className="w-full sm:w-[30rem]">
        <Button onClick={submitSerialNumber} disabled={serialNumber.length < 5 || loading} loading={loading}>
          Submit
        </Button>
      </div>
    </>
  );
}
